module.exports = __webpack_public_path__ + "static/media/on-court-training.23225e47.jpg";